import { useOwnChatStream } from "src/reusable/Chat/ChatStreaming/hooks/useOwnChatStream";
import { nuclearn_api_url } from "src/App";
import { ChatConfiguration } from "src/reusable/Chat/ChatStreaming/types";
import useAtomAssistEventHandlers from "src/views/assistant/hooks/useAtomAssistEventHandlers";
import { ChatMessageWithParts } from "src/views/assistant/types";

/**
 * The event handlers are required, not decoration: ``connectSSE`` defaults
 * them to no-ops, and without ``onMessageEvent`` nothing renders live — the
 * reply only appears after a reload. ``onMetadataEvent`` carries citations.
 */
export const useItemEquivalencyChat = (
  config?: Partial<ChatConfiguration>,
  dialogue?: ChatMessageWithParts[],
) => {
  const { metadataHandler, messageHandler } = useAtomAssistEventHandlers();

  return useOwnChatStream(
    {
      api: `${nuclearn_api_url}/chat/start`,
      onMetadataEvent: metadataHandler,
      onMessageEvent: messageHandler,
      ...config,
    },
    dialogue,
  );
};
